import * as React from 'react';
import { GcHeaderCustomMenuLabel } from '../../common/menu/gc-header-custom-menu-label';
import { MenuItemSectionLabelType } from '@gc/global-controls-store';
export var HeaderSignedInHeading = function (_a) {
  var userFirstName = _a.userFirstName,
    memberStatus = _a.memberStatus;
  return React.createElement("div", {
    className: "header-signed-in-heading"
  }, React.createElement("div", {
    className: "heading-container"
  }, React.createElement(GcHeaderCustomMenuLabel, {
    text: userFirstName,
    type: MenuItemSectionLabelType.HEADING
  }), React.createElement(GcHeaderCustomMenuLabel, {
    text: memberStatus,
    type: MenuItemSectionLabelType.SUBHEADING,
    padding: {
      top: true
    }
  })));
};